/* eslint-disable prettier/prettier */

import './index_web.css';
import { useEffect, useState } from 'react';
import { getNoPlayingCount, getPlayerName, getTeamPlayerCount } from '../../../utilities/helper';
import useTheme from '../../../utilities/hooks/theme';
import I18n from '../../../utilities/locale';
import { FaEdit, FaClone, FaClipboardList } from 'react-icons/fa';
import { Card, View, Text } from '../../../component';
import Button from '@mui/material/Button/Button';
import React from 'react';
import Constants from '../../../constants';
import { useSelector } from 'react-redux';

interface teamPlayerTypeProps {
  playerRole?: string;
  playerRoleCount?: number;
  theme?: any;
}

const TeamPlayerType = ({ playerRole, playerRoleCount, theme }: teamPlayerTypeProps) => {
  const playerTypeTitle = {
    color: theme.teamBoxPlayerTypeTitle
  };
  const playerTypeValue = {
    color: theme.teamBoxPlayerTypeValue
  };
  return (
    <View className="team-box-content-player-wrapper">
      <Text className="team-box-content-player-type-value" style={playerTypeValue}>
        {playerRoleCount}
      </Text>
      <Text className="team-box-content-player-type" style={playerTypeTitle}>
        {playerRole}
      </Text>
    </View>
  );
};

interface cricketTeamPlayerTypeProps {
  teamCountCricket?: any;
  theme?: any;
}

const CricketTeamPlayerType = ({ teamCountCricket, theme }: cricketTeamPlayerTypeProps) => {
  return (
    <View className="team-box-content-player">
      <TeamPlayerType
        playerRoleCount={teamCountCricket['wkCount']}
        playerRole={'W/K'}
        theme={theme}
      />
      <TeamPlayerType
        playerRoleCount={teamCountCricket['batsmanCount']}
        playerRole={'Bat'}
        theme={theme}
      />
      <TeamPlayerType
        playerRoleCount={teamCountCricket['allRounderCount']}
        playerRole={'A/R'}
        theme={theme}
      />

      <TeamPlayerType
        playerRoleCount={teamCountCricket['bowlerCount']}
        playerRole={'Bowl'}
        theme={theme}
      />
    </View>
  );
};

interface footballTeamPlayerTypeProps {
  teamCountFootball?: any;
  theme?: any;
}

const FootballTeamPlayerType = ({ teamCountFootball, theme }: footballTeamPlayerTypeProps) => {
  return (
    <View className="team-box-content-player">
      <TeamPlayerType
        playerRoleCount={teamCountFootball['gkCount']}
        playerRole={'G/K'}
        theme={theme}
      />
      <TeamPlayerType
        playerRoleCount={teamCountFootball['defenderCount']}
        playerRole={'DEF'}
        theme={theme}
      />
      <TeamPlayerType
        playerRoleCount={teamCountFootball['midfielderCount']}
        playerRole={'MID'}
        theme={theme}
      />

      <TeamPlayerType
        playerRoleCount={teamCountFootball['forwardCount']}
        playerRole={'ST'}
        theme={theme}
      />
    </View>
  );
};

interface substituteTeamPlayerTypeProps {
  teamCountCricket?: any;
  theme?: any;
}

const SubstituteTeamPlayerType = ({ teamCountCricket, theme }: substituteTeamPlayerTypeProps) => {
  return (
    <View className="team-box-content-player">
      <TeamPlayerType
        playerRoleCount={teamCountCricket['wkCount']}
        playerRole={'W/K'}
        theme={theme}
      />
      <TeamPlayerType
        playerRoleCount={teamCountCricket['batsmanCount']}
        playerRole={'Bat'}
        theme={theme}
      />
      <TeamPlayerType
        playerRoleCount={teamCountCricket['allRounderCount']}
        playerRole={'A/R'}
        theme={theme}
      />

      <TeamPlayerType
        playerRoleCount={teamCountCricket['bowlerCount']}
        playerRole={'Bowl'}
        theme={theme}
      />
      <TeamPlayerType
        playerRoleCount={teamCountCricket['substituteCount']}
        playerRole={'Subs'}
        theme={theme}
      />
    </View>
  );
};

interface kabaddiTeamPlayerTypeProps {
  teamCountKabaddi?: any;
  theme?: any;
}

const KabaddiTeamPlayerType = ({ teamCountKabaddi, theme }: kabaddiTeamPlayerTypeProps) => {
  return (
    <View className="team-box-content-player">
      <TeamPlayerType
        playerRoleCount={teamCountKabaddi['raiderCount']}
        playerRole={'RAI'}
        theme={theme}
      />
      <TeamPlayerType
        playerRoleCount={teamCountKabaddi['allRounderCount']}
        playerRole={'A/R'}
        theme={theme}
      />

      <TeamPlayerType
        playerRoleCount={teamCountKabaddi['defenderCount']}
        playerRole={'DEF'}
        theme={theme}
      />
    </View>
  );
};
interface Props {
  onPressPreview?: any;
  item: any;
  onPressEdit?: any;
  onPressClone?: any;
  joinedMatch?: boolean;
  selectTeamByUser: any;
  lineupsOut: boolean;
  onPressAlreadyJoin?: any;
  title?: string;
  matchAllPlayersList: any;
  contestTeams: any;
  gameType?: string;
  onPressConvertSubstituteMode: any;
  tabType: any;
}

const TeamBox = ({
  onPressPreview,
  item,
  onPressClone,
  onPressEdit,
  joinedMatch,
  selectTeamByUser,
  onPressAlreadyJoin,
  matchAllPlayersList = [],
  lineupsOut = false,
  contestTeams = [],
  gameType = '',
  onPressConvertSubstituteMode,
  tabType
}: Props) => {
  const { FantasyTheme: theme } = useTheme();
  const [alreadyJoined, setAlreadyJoined] = useState(false);
  const [nonPlayingPlayerCount, setNonPlayingPlayerCount] = useState(0);
  let { themeType = '' } = useSelector((state: any) => state.setting);
  const [teamCount, setTeamCount] = useState({
    batsmanCount: 0,
    wkCount: 0,
    allRounderCount: 0,
    bowlerCount: 0,
    raiderCount: 0,
    defenderCount: 0,
    substituteCount: 0,
    gkCount: 0,
    forwardCount: 0,
    midfielderCount: 0
  });

  const {
    id: matchTeamId = '',
    captain = {},
    viceCaptain = {},
    players = [],
    teamNumber = 1,
    isSelected = false
  } = item;
  const { shortName: captainName = '' } = captain;
  const { shortName: viceCaptainName = '' } = viceCaptain;
  useEffect(() => {
    if (lineupsOut) {
      const count = getNoPlayingCount(matchAllPlayersList, players);
      setNonPlayingPlayerCount(count);
    }
    const isAlreadyJoinedIndex = contestTeams.findIndex(function (item: { matchTeamId: any }) {
      return item.matchTeamId === matchTeamId;
    });
    setTeamCount(() => {
      return getTeamPlayerCount(players);
    });

    setAlreadyJoined(isAlreadyJoinedIndex !== -1 ? true : false);
  }, [matchAllPlayersList, players, lineupsOut, contestTeams]);

  const _onPressTeam = (event: any) => {
    event?.stopPropagation();
    if (joinedMatch) {
      if (alreadyJoined) onPressAlreadyJoin();
      else selectTeamByUser(teamNumber - 1);
    }
  };

  const _onPressConvertSubstituteMode = (event: any) => {
    event?.stopPropagation();
    onPressConvertSubstituteMode(item, teamNumber);
  };

  const _onPressEdit = (event: any) => {
    event?.stopPropagation();
    onPressEdit(item, teamNumber);
  };

  const _onPressPreview = (event: any) => {
    event?.stopPropagation();
    onPressPreview(item, teamNumber);
  };
  const _onPressClone = (event: any) => {
    event?.stopPropagation();
    onPressClone(item, teamNumber);
  };

  const containerColor = {
    backgroundColor: 'transparent',
    padding: '0px !Important',
    border: themeType === 'dark' ? ' ' : `0px 1px 1px 1px solid ${theme.teamBoxSeparator}`,
    borderRadius: '10px 10px 7px 7px'
  };
  const teamNameContainerColor = {
    border: themeType === 'dark' ? '' : `1px solid ${theme.teamBoxSeparator}`,
    background: theme.teamBoxTopContentBg,
    boxShadow: theme.teamBoxTopContentBoxShadow
  };

  const teamNumberColor = {
    color: theme.teamBoxTitle
  };
  const teamBoxNotPlayingCount = {
    color: theme.teamBoxNotPlayingCount
  };
  const bottomButtonTextColor = {
    color: theme.teamBoxBtnText
  };

  const captainTitle = {
    color: theme.teamBoxCaptainTitle
  };

  const captainCircleBG = {
    backgroundColor: theme.teamBoxCaptainCircleBG
  };

  const captainCircleTitle = {
    color: theme.teamBoxCaptainCircleText
  };

  const iconDimension = '18px';
  const teamBoxBottomContentStyle = {
    background: theme.teamBoxBottomContentBG,
    boxShadow: theme.teamBoxBottomContentBoxShadow
  };
  return (
    <Card style={containerColor} onPress={_onPressTeam} className="team-box-container">
      <View className="team-box-name-container" style={teamNameContainerColor}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center'
          }}>
          <View onPress={_onPressTeam}>
            <Text className="team-box-number" style={teamNumberColor}>{`Team ${teamNumber}`}</Text>
          </View>
        </View>
        {nonPlayingPlayerCount > 0 && (
          <View>
            <Text style={teamBoxNotPlayingCount} className={'team-box-not-playing'}>
              {`* ${nonPlayingPlayerCount} ${I18n.t('playerAreNotPlayingMsg')}`}
            </Text>
          </View>
        )}
        {gameType === Constants.GameType.FANTASY_SUBSTITUTION && (
          <Button
            style={{
              backgroundColor: theme.teamBoxSubstituteBtnBG,
              borderRadius: '5px'
            }}
            className={'team-box-add-substitute-button'}
            onClick={_onPressConvertSubstituteMode}>
            {teamCount.substituteCount >= 3 ? 'Edit Substitutes' : 'Add Substitutes'}
          </Button>
        )}
      </View>
      {gameType === Constants.GameType.FANTASY_SUBSTITUTION && teamCount['substituteCount'] > 0 && (
        <View style={teamNameContainerColor} className={'team-box-substitute-count-wrapper'}>
          <Text style={teamNumberColor} className={'team-box-substitute-count'}>{`* ${
            teamCount['substituteCount']
          } ${I18n.t('subsAdded')}`}</Text>
        </View>
      )}
      <div className="team-box-content-container" style={teamBoxBottomContentStyle}>
        <div
          className="team-box-content-col1"
          style={{ borderRight: `1px solid ${theme.teamBoxSeparator}` }}>
          <div style={{ display: 'flex', flexDirection: 'row', margin: '4px 0px 10px 0px' }}>
            <Text className="team-box-captain-name-title" style={captainTitle}>
              {getPlayerName(captainName)}
            </Text>
            <View className="team-box-captain-vice-captain-circle" style={captainCircleBG}>
              <Text className="team-box-captain-vice-captain-text" style={captainCircleTitle}>
                {'C'}
              </Text>
            </View>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Text className="team-box-captain-name-title" style={captainTitle}>
              {getPlayerName(viceCaptainName)}
            </Text>
            <View className="team-box-captain-vice-captain-circle" style={captainCircleBG}>
              <Text className="team-box-captain-vice-captain-text" style={captainCircleTitle}>
                {'VC'}
              </Text>
            </View>
          </div>
        </div>
        <div className="team-box-content-col2">
          {gameType === Constants.GameType.FANTASY_CRICKET && (
            <CricketTeamPlayerType teamCountCricket={teamCount} theme={theme} />
          )}
          ``
          {gameType === Constants.GameType.FANTASY_SUBSTITUTION && (
            <SubstituteTeamPlayerType teamCountCricket={teamCount} theme={theme} />
          )}
          {gameType === Constants.GameType.FANTASY_KABADDI && (
            <KabaddiTeamPlayerType teamCountKabaddi={teamCount} theme={theme} />
          )}
          {gameType === Constants.GameType.FANTASY_FOOTBALL && (
            <FootballTeamPlayerType teamCountFootball={teamCount} theme={theme} />
          )}
          {joinedMatch && (
            <button
              onClick={_onPressTeam}
              className="teamBox__select__btn"
              style={{ backgroundColor: isSelected ? 'rgb(255, 59, 60)' : ' #49bf6a' }}>
              {isSelected ? 'Deselect' : 'Select'}
            </button>
          )}
        </div>
      </div>
      {tabType === 'FIXTURE' && (
        <div
          className="team-box-bottom-button-wrapper"
          style={{
            ...teamBoxBottomContentStyle,
            borderTop: `1px solid ${theme.teamBoxSeparator}`
          }}>
          <View onPress={_onPressEdit} className={'team-box-edit-clone-button'}>
            <FaEdit fill={theme.teamBoxBottomIcon} size={iconDimension} />
            <Text className="team-box-bottom-btn-text" style={bottomButtonTextColor}>
              {'Edit Team'}
            </Text>
          </View>

          <View onPress={_onPressPreview} className={'team-box-edit-clone-button'}>
            <FaClipboardList fill={theme.teamBoxBottomIcon} size={iconDimension} />

            <Text className="team-box-bottom-btn-text" style={bottomButtonTextColor}>
              {I18n.t('Preview')}
            </Text>
          </View>
          <View onPress={_onPressClone} className={'team-box-edit-clone-button'}>
            <FaClone fill={theme.teamBoxBottomIcon} size={iconDimension} />
            <Text className="team-box-bottom-btn-text" style={bottomButtonTextColor}>
              {'Clone Team'}
            </Text>
          </View>
        </div>
      )}
    </Card>
  );
};
TeamBox.defaultProps = {
  onPressConvertSubstituteMode: () => {},
  tabType: ''
};
export default React.memo(TeamBox);
